module.exports = __webpack_public_path__ + "img/beex-light-medium.03072896.svg";